import { Component } from '../../decorators/component.decorator';
import { Attribute } from '../../decorators/attribute.decorator';
import { UIIconColors } from '../icon/ui-icon.helpers';
import { UIOption } from './ui-option';
import type { ElementConfig } from '../ui-element.type';
import styles from './ui-option-lang.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIOption}
 * @alias UIOptionLang
 * @element ui-option-lang
 * @classdesc Represents a class for <code>ui-option-lang</code> element.
 * Used with <code>ui-dropdown layout="lang"</code> and <code>ui-option-list</code>.
 * @property {string} [color] {@attr color} Color for the arrow icon.
 * @example
 * <ui-dropdown layout="lang" hide-selected>
 *   <select>
 *     <option value="en" selected>English</option>
 *     <option value="et">Estonian</option>
 *   </select>
 * </ui-dropdown>
 * @example
 * <ui-option-list label="Select language">
 *   <ui-option-lang value="en" text="English" selected></ui-option-lang>
 *   <ui-option-lang value="et" text="Estonian"></ui-option-lang>
 *   <ui-option-lang value="lv" text="Latvian"></ui-option-lang>
 * </ui-option-list>
 */
@Component({
    tag: 'ui-option-lang',
    styles,
})
export class UIOptionLang extends UIOption {
    static readonly HandlesOwnControl = true;

    @Attribute(String) color?: string;

    /**
     * @inheritDoc
     */
    render(): void {
        this.updateClassList({
            'ui-option-lang': true,
        });

        this.insertElements(
            (this.optgroup
                ? [this.buildOptGroupLabel()]
                : [
                      {
                          tagName: 'span',
                          children: [this.text || this.value],
                      },
                      this.control
                          ? {
                                tagName: 'ui-icon',
                                attributes: {
                                    glyph: 'redesign-chevron-down',
                                    color: this.color ?? UIIconColors.ORANGE,
                                },
                            }
                          : undefined,
                  ].filter(Boolean)) as Array<
                HTMLElement | DocumentFragment | ElementConfig
            >
        );

        super.render();
    }
}
